import Vue from "vue";
import VueLocalStorage from "vue-localstorage";
import * as VueGoogleMaps from "vue2-google-maps";
// import VuetifyGoogleAutocomplete from "vuetify-google-autocomplete";
// import VueApexCharts from "vue-apexcharts";
// import GmapCluster from "vue2-google-maps/dist/components/cluster";
// import "material-design-icons-iconfont/dist/material-design-icons.css";

// Vue.use(Vuetify);
// Vue.use(VueApexCharts);
// Vue.component("apexchart", VueApexCharts);

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: "AIzaSyA9b2YFB2qkiT-wt5EoVXrub2b7eY6frS0",
//     // This is required to use the Autocomplete plugin
//     libraries: "places" // 'places,drawing,visualization'
//   }
// });

// Vue.component("GmapCluster", GmapCluster);
// Vue.use(VuetifyGoogleAutocomplete, {
//   /*
//     not used as loaded with component
//     apiKey: key,
//   */
//   vueGoogleMapsCompatibility: true
// });

// Vue.use(VuetifyGoogleAutocomplete, {
//   apiKey: "AIzaSyA9b2YFB2qkiT-wt5EoVXrub2b7eY6frS0", // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
//   // apiKey: "AIzaSyBM8hnoBAdmhnRlN1IKe-Hv859G86QgyT4", // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
//   installComponents: true, // Optional (default: true) - false, if you want to locally install components
//   vueGoogleMapsCompatibility: false // Optional (default: false) - true, requires vue2-google-maps to be configured see https://github.com/xkjyeah/vue-google-maps
// });

export default ({ $config }) => {
  Vue.use(VueLocalStorage, {
    name: "ls",
    bind: true //created computed members from your variable declarations
  });
  Vue.use(VueGoogleMaps, {
    load: {
      key: $config.GMAP_API_KEY,
      libraries: "places"
    }
  });
};
